// Cookie consent management — GDPR / Garante Privacy compliant.
// Stores the user's choice locally and notifies the tracking layer, which only
// loads Google Analytics / Google Ads / Meta Pixel AFTER the matching consent.

const KEY = "cookie_consent_v1";

export const CONSENT_EVENT = "cookie-consent-updated";
export const OPEN_PREFS_EVENT = "open-cookie-preferences";

export function getConsent() {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function hasDecision() {
  return !!getConsent();
}

export function saveConsent({ analytics, marketing }) {
  const value = {
    necessary: true,
    analytics: !!analytics,
    marketing: !!marketing,
    ts: new Date().toISOString(),
  };
  try {
    window.localStorage.setItem(KEY, JSON.stringify(value));
  } catch {
    /* storage disabled — consent still applies for this session */
  }
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: value }));
  return value;
}

export function acceptAll() {
  return saveConsent({ analytics: true, marketing: true });
}

export function rejectAll() {
  return saveConsent({ analytics: false, marketing: false });
}

// Re-open the preferences dialog (used from the footer link).
export function openPreferences() {
  window.dispatchEvent(new Event(OPEN_PREFS_EVENT));
}
